const uri = '/webapi/xm/1/people';

export const USERS_LIST_PAGE_POST_USER = 'USERS_LIST_PAGE_POST_USER';
export const USERS_LIST_PAGE_POST_USER_START = `${USERS_LIST_PAGE_POST_USER}_START`;
export const USERS_LIST_PAGE_POST_USER_SUCCESS = `${USERS_LIST_PAGE_POST_USER}_SUCCESS`;
export const USERS_LIST_PAGE_POST_USER_FAIL = `${USERS_LIST_PAGE_POST_USER}_FAIL`;

export const createUser = person => ({
  type: USERS_LIST_PAGE_POST_USER,
  meta: {
    xmApi: true,
    method: 'post',
    uri: `${uri}`,
    params: person,
  },
});

export const POPULATE_RECENTLY_ADDED_USERS = 'POPULATE_RECENTLY_ADDED_USERS';

export const populateRecentlyAddedUsers = () => ({
  type: POPULATE_RECENTLY_ADDED_USERS,
});

export const REMOVE_RECENTLY_ADDED_USERS = 'REMOVE_RECENTLY_ADDED_USERS';
export const removeRecentlyAddedUsers = payload => ({
  type: REMOVE_RECENTLY_ADDED_USERS,
  payload,
});

export const CLEAR_RECENTLY_ADDED_USERS = 'CLEAR_RECENTLY_ADDED_USERS';

export const clearRecentlyAddedUsers = () => ({
  type: CLEAR_RECENTLY_ADDED_USERS,
});

export const OPEN_DIALOG = 'OPEN_DIALOG';

export const openDialog = () => ({
  type: OPEN_DIALOG,
});

export const CLOSE_DIALOG = 'CLOSE_DIALOG';

export const closeDialog = () => ({
  type: CLOSE_DIALOG,
});

export const SET_CREATE_ANOTHER_USER = 'SET_CREATE_ANOTHER_USER';

export const setCreateAnotherUser = payload => ({
  type: SET_CREATE_ANOTHER_USER,
  payload,
});

export const SET_COPY_SETTINGS = 'SET_COPY_SETTINGS';

export const setCopySettings = payload => ({
  type: SET_COPY_SETTINGS,
  payload,
});

export const USERS_LIST_SEND_WELCOME_MESSAGE =
  'USERS_LIST_SEND_WELCOME_MESSAGE';
export const USERS_LIST_SEND_WELCOME_MESSAGE_START = `${USERS_LIST_SEND_WELCOME_MESSAGE}_START`;
export const USERS_LIST_SEND_WELCOME_MESSAGE_SUCCESS = `${USERS_LIST_SEND_WELCOME_MESSAGE}_SUCCESS`;
export const USERS_LIST_SEND_WELCOME_MESSAGE_FAIL = `${USERS_LIST_SEND_WELCOME_MESSAGE}_FAIL`;

export const sendWelcomeMessage =
  recipients =>
  ({ subject, customMessage, signature }) => ({
    type: USERS_LIST_SEND_WELCOME_MESSAGE,
    meta: {
      xmApi: true,
      method: 'post',
      uri: '/webapi/xm/1/system-messages/user-onboarding/trigger',
      params: {
        recipients,
        subject,
        message: customMessage,
        signature,
      },
    },
  });

export const SET_CAN_COPY_SETTINGS = 'SET_CAN_COPY_SETTINGS';

export const setCanCopySettings = payload => ({
  type: SET_CAN_COPY_SETTINGS,
  payload,
});
